var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8399 29L23.1497 22.4856M23.1497 22.4856C24.2941 21.3713 25.2019 20.0484 25.8212 18.5924C26.4405 17.1365 26.7593 15.5761 26.7593 14.0002C26.7593 12.4243 26.4405 10.8638 25.8212 9.4079C25.2019 7.95198 24.2941 6.62909 23.1497 5.51477C22.0053 4.40045 20.6467 3.51652 19.1515 2.91346C17.6563 2.31039 16.0537 2 14.4353 2C12.8169 2 11.2143 2.31039 9.71913 2.91346C8.22391 3.51652 6.86533 4.40045 5.72094 5.51477C3.40974 7.76524 2.11133 10.8175 2.11133 14.0002C2.11133 17.1828 3.40974 20.2351 5.72094 22.4856C8.03214 24.736 11.1668 26.0003 14.4353 26.0003C17.7038 26.0003 20.8385 24.736 23.1497 22.4856Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bb9940717065428af860fcf65f5bb765.svg";
export { ForwardRef as ReactComponent };